import React from 'react';
import './CharacterCard.css';

const CharacterCard = ({ character }) => {
  // Normalize affiliation to CSS class name
  const getAffiliationClass = (affiliation) => {
    const normalized = affiliation.toLowerCase().replace(/'/g, '').replace(/\s+/g, '-');
    if (normalized.includes('chaostamers')) return 'affiliation-chaostamers';
    if (normalized.includes('neutral')) return 'affiliation-neutral';
    if (normalized.includes('purger')) return 'affiliation-purgers';
    if (normalized.includes('tribunal')) return 'affiliation-tribunal';
    if (normalized.includes('payton') || normalized.includes('paytons-gang')) return 'affiliation-paytons-gang';
    // Default to neutral for other affiliations
    return 'affiliation-neutral';
  };

  const affiliationClass = getAffiliationClass(character.affiliation);

  return (
    <div className={`character-card ${affiliationClass}`}>
      <h2 className="character-name">{character.name}</h2>
      <div className="character-content">
        <div className="character-image">
          {character.image ? (
            <img src={character.image} alt={character.name} />
          ) : (
            <div className="placeholder-image">
              <span>{character.name.charAt(0)}</span>
            </div>
          )}
        </div>
        <div className="character-details">
          <div className="detail-item">
            <span className="detail-label">Name:</span>
            <span className="detail-value">{character.name}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Gender:</span>
            <span className="detail-value">{character.gender}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Species:</span>
            <span className="detail-value">{character.species}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Affiliation:</span>
            <span className="detail-value">{character.affiliation}</span>
          </div>
          {character.description && (
            <div className="detail-item full-width">
              <span className="detail-label">Description:</span>
              <p className="detail-text">{character.description}</p>
            </div>
          )}
          {character.link && (
            <div className="character-link-container">
              <a 
                href={character.link} 
                target="_blank" 
                rel="noopener noreferrer"
                className="character-link-btn"
              >
                <span>Chat with {character.name}</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 3L11 8L6 13M11 8H1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CharacterCard;

